/** Local storage key that holds current user ID */
export const userKey = 'vsuite_user';

/** User details tabs */
export const USERS_DETAIL_TABS = {
  ACCESS: 'access',
  PERMISSIONS: 'permissions',
} as const;
